import { Children, FC, MouseEvent, useState } from 'react';
import styled from 'styled-components';
import { Avatar } from '../../Avatar/Avatar';
import { ClickAwayListener } from '../../ClickAwayListener/ClickAwayListener';
import { Portal } from '../../Portal/Portal';

/*
REUSED CODE FROM OLD NAV
*/

const NavControlElement = styled.div<ICommonProps>`
  display: inline-block;
  width: 46px;
  position: relative;
  background-color: ${({ selected, theme }) => (selected ? theme.vars.newColor.blue1 : theme.vars.newColor.darkGS1)};
`;

const MenuListElement = styled.ul<ICommonProps>`
  margin: 0;
  padding: 0;
  margin-top: 5px;
  width: 200px;
  left: 20px;
  right: 20px;
  overflow-y: auto;
  position: absolute;
  top: ${({ menuDirection }) => (menuDirection === 'up' ? null : '60px')};
  bottom: ${({ menuDirection }) => (menuDirection === 'up' ? '60px' : null)};
  z-index: 10;
  background-color: #fff;
  text-decoration: none;
  margin-bottom: 5px;
`;

const ButtonElement = styled.button<{
  allowMenu: boolean;
  customOnClick: () => void;
}>`
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  color: #fff;
  background-color: inherit;
  outline-offset: -4px;
  padding: 0 15px;
  height: 46px;
  border-radius: 0px;
  border: 0px;
  cursor: ${({ allowMenu, customOnClick }) => (allowMenu || customOnClick ? 'pointer' : 'default')};

  &:hover {
    background-color: ${({ allowMenu, customOnClick, theme }) =>
      allowMenu || customOnClick ? theme.vars.newColor.blue2 : theme.vars.newColor.darkGS1};
    .action-icon__container {
      svg {
        color: #fff;
      }
    }
  }
`;

const ButtonInnerElement = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
`;

export type MenuDirection = 'up' | 'down';

interface ICommonProps {
  selected?: boolean;
  menuDirection?: MenuDirection;
}

export interface INavControlProps extends ICommonProps {
  showAvatar?: boolean;
  label: string;
  subLabel?: string;
  avatarImage?: string;
  avatarIcon?: string;
  avatarBgColor?: string;
  actionIcon?: string;
  onClick?: () => void;
  enableMenu?: boolean;
  ariaLabel?: string;
}

const defaultProps: Pick<INavControlProps, 'showAvatar' | 'enableMenu'> = {
  showAvatar: true,
  enableMenu: true,
};

export const MainNavFooter: FC<INavControlProps> = props => {
  const [showMenu, setShowMenu] = useState(false);
  const numChildren = Children.count(props.children);
  const allowMenu = numChildren > 0 && props.enableMenu;

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleButtonClick = (event: MouseEvent) => {
    event.stopPropagation();
    if (allowMenu) {
      toggleMenu();
    }
    if (props.onClick) {
      props.onClick();
    }
  };

  const handleClickAway = () => {
    setShowMenu(false);
  };

  return (
    <NavControlElement data-testid="NavControl" selected={props.selected}>
      <ButtonElement
        allowMenu={allowMenu}
        onClick={handleButtonClick}
        customOnClick={props.onClick}
        type="button"
        disabled={!props.onClick && !allowMenu}
        data-testid="NavControlButton"
        aria-label={props.ariaLabel}
      >
        <ButtonInnerElement>
          {props.showAvatar && <Avatar icon={props.avatarIcon} bg={props.avatarBgColor} image={props.avatarImage} />}
        </ButtonInnerElement>
      </ButtonElement>
      {showMenu && (
        <Portal>
          <ClickAwayListener onClickAway={handleClickAway}>
            <MenuListElement onClick={handleClickAway} menuDirection={props.menuDirection}>
              {props.children}
            </MenuListElement>
          </ClickAwayListener>
        </Portal>
      )}
    </NavControlElement>
  );
};

MainNavFooter.defaultProps = defaultProps;
